/*! zk-mini-cart — COD/Prepaid + FastTrak + offers popup */
(function () {
  if (window.__zkMcUi) return;
  window.__zkMcUi = true;

  function openFastrrCheckout(e) {
    try {
      if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') {
        window.shiprocketCheckoutEvents.buyCart(e || { stopPropagation: function () {} });
        return true;
      }
      if (window.HeadlessCheckout && typeof window.HeadlessCheckout.checkout === 'function') {
        window.HeadlessCheckout.checkout(e || { stopPropagation: function () {} });
        return true;
      }
      var sr = document.querySelector('.sr-headless-checkout, .shiprocket-headless[data-type="mini-cart"] .sr-headless-checkout, .shiprocket-headless[data-type="cart"] .sr-headless-checkout');
      if (sr) {
        sr.click();
        return true;
      }
    } catch (err) {}
    return false;
  }

  function getOffersPop() {
    return document.getElementById('zk-mc-offers-pop') || document.querySelector('.zk-mc-offers-pop');
  }

  function openOffers() {
    var pop = getOffersPop();
    if (!pop) return;
    pop.hidden = false;
    pop.removeAttribute('hidden');
    pop.setAttribute('aria-hidden', 'false');
    pop.classList.add('is-open');
    document.documentElement.classList.add('zk-mc-offers-open');
    var closeBtn = pop.querySelector('[data-zk-offers-close]');
    if (closeBtn) try { closeBtn.focus(); } catch (err) {}
  }

  function closeOffers() {
    var pop = getOffersPop();
    if (!pop) return;
    pop.hidden = true;
    pop.setAttribute('hidden', '');
    pop.setAttribute('aria-hidden', 'true');
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('zk-mc-offers-open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('zk-mc-offers-open')) {
      closeOffers();
    }
  });

  document.addEventListener('click', function (e) {
    var offersOpen = e.target.closest('[data-zk-offers-open], .zk-mc-deals-trigger');
    if (offersOpen) {
      e.preventDefault();
      e.stopPropagation();
      openOffers();
      return;
    }

    var offersClose = e.target.closest('[data-zk-offers-close]');
    if (offersClose) {
      e.preventDefault();
      e.stopPropagation();
      closeOffers();
      return;
    }

    var openDeals = e.target.closest('[data-zk-open-deals]');
    if (openDeals) {
      e.preventDefault();
      openOffers();
      return;
    }

    var checkoutBtn = e.target.closest('.zk-mc-checkout, button.zk-mc-checkout');
    if (checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (!openFastrrCheckout(e)) {
        var form = checkoutBtn.closest('form');
        if (form) {
          var fake = document.createElement('input');
          fake.type = 'hidden';
          fake.name = 'checkout';
          fake.value = '1';
          form.appendChild(fake);
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      }
      return;
    }

    var payOpt = e.target.closest('[data-zk-pay]');
    if (payOpt) {
      var root = payOpt.closest('.zk-mc-summary--c');
      if (!root) return;
      e.preventDefault();
      var mode = payOpt.getAttribute('data-zk-pay');
      root.querySelectorAll('[data-zk-pay]').forEach(function (b) {
        var on = b === payOpt;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var amt = root.querySelector('[data-zk-pay-amt]');
      var note = root.querySelector('[data-zk-pay-note]');
      if (mode === 'prepaid') {
        if (amt) amt.textContent = root.getAttribute('data-zk-prepaid-money') || '';
        if (note) {
          note.textContent = (root.getAttribute('data-zk-prepaid-off') || '') + ' prepaid offer applied';
          note.classList.remove('is-muted');
        }
      } else {
        if (amt) amt.textContent = root.getAttribute('data-zk-cod-money') || '';
        if (note) {
          note.textContent = 'Pay when your order is delivered';
          note.classList.add('is-muted');
        }
      }
      return;
    }

    var btn = e.target.closest('[data-zk-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-zk-copy') || '';
    var label = btn.querySelector('[data-zk-copy-label]');
    function done() {
      if (!label) return;
      var prev = label.textContent;
      label.textContent = 'Copied';
      setTimeout(function () { label.textContent = prev || 'Copy'; }, 1400);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () {
        try {
          var t = document.createElement('textarea');
          t.value = code;
          document.body.appendChild(t);
          t.select();
          document.execCommand('copy');
          document.body.removeChild(t);
          done();
        } catch (err) {}
      });
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    if (!form.closest('#mini-cart, .cart-drawer, mini-cart')) return;
    var submitter = e.submitter || document.activeElement;
    if (submitter && submitter.closest && submitter.closest('.zk-mc-checkout')) {
      e.preventDefault();
      e.stopPropagation();
      openFastrrCheckout(e);
    }
  }, true);
})();
